/** psettings: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "secDevice": "Device",
  "idleScreen": "Idle screen",
  "restart": "Restart schedule",
  "dataSaving": "Data saving",
  "location": "Check its location",
  "locationShort": "Location",
  "locationHint": "How often an Android player looks for its position (Wi-Fi/GPS). Regions and weather or prayer apps follow it. Every 30 minutes suits fixed screens; a few minutes suits screens in vehicles.",
  "locEveryMin": "Every minute | Every {n} minutes",
  "locEveryHour": "Every hour | Every {n} hours",
  "onceADay": "Once a day",
  "idleStandby": "Standby mark (default)",
  "idleBlack": "Black screen",
  "idleLogo": "Your logo",
  "idleMessage": "A message",
  "idleImage": "Logo image",
  "chooseImage": "Choose an image…",
  "noImages": "Upload an image to Content first.",
  "idleText": "Message",
  "idleTextPh": "e.g. Welcome! Content coming soon.",
  "background": "Background",
  "textColor": "Text",
  "idleHint": "Shows when nothing is scheduled, and outside working hours when those are set to standby. A logo is downloaded with the content, so it shows offline.",
  "restartDaily": "Restart the player every day",
  "restartTime": "Restart time",
  "restartHint": "On the screen's own clock. No days chosen = every day. The player is back on screen within a minute.",
  "restartAt": "{time}, {days}",
  "savingOn": "Download new content only at certain times",
  "savingWifi": "On Android, only on Wi-Fi (not mobile data)",
  "savingHint": "Saves data on metered or busy connections. What's already on the player keeps playing; new content arrives in the window. A new player with nothing to show downloads straight away.",
  "savingAt": "Downloads {from}–{to}",
  "idleShort": "Idle",
  "restartShort": "Restart",
  "savingShort": "Data saving",
  "deviceLogs": "Device logs",
  "logsShort": "Logs",
  "logWarn": "Warnings and errors",
  "logError": "Errors only",
  "logOff": "Don't collect logs",
  "logCollect": "What to collect",
  "logSend": "How often to send",
  "sendX": "Send {when}",
  "everyMinute": "Every minute",
  "logsHint": "What the player records and how often it sends it (shown in the player's Errors & Warnings and used by Health Check). Less often saves data on metered connections; errors are still kept on the player until sent.",
  "useGroupOrOrg": "Use group / organization setting",
  "orientQ": "Change orientation to {label}? The screen rotates and re-lays out as soon as the player gets the change.",
  "scheduleLine": "{days} · {times} · outside: {outside}",
  "pct": "{n}%",
  "displayLine": "Brightness {b} · {o}",
  "everyNMin": "Every {n} minutes",
  "everyNHours": "Every {n} hours",
  "windowFrom": "Window {n} from",
  "windowTo": "Window {n} to",
  "secSchedule": "Working Schedule",
  "secDisplay": "Display",
  "secSound": "Sound",
  "secMonitoring": "Monitoring",
  "invalid": "Invalid settings",
  "landscape": "Landscape",
  "portrait": "Portrait",
  "landscapeFlipped": "Landscape (flipped 180°)",
  "portraitFlipped": "Portrait (flipped 180°)",
  "outBlack": "black screen, sound off",
  "outStandby": "standby screen, sound off",
  "alwaysOn": "Always on",
  "everyDay": "Every day",
  "allDay": "all day",
  "defaultVol": "Default (100%)",
  "muted": "Muted",
  "asDevice": "as set on the device",
  "everyHour": "Every hour",
  "shotsOff": "Screenshots off",
  "wifiOnly": "only on Wi-Fi or Ethernet",
  "anyNetwork": "on any network",
  "saving": "Saving…",
  "save": "Save",
  "openOn": "Open on",
  "outsideHours": "Outside working hours",
  "brightness": "Brightness",
  "orientation": "Orientation",
  "volume": "Volume",
  "screenshots": "Screenshots",
  "useDefault": "Use organization default",
  "days": "Days",
  "to": "to",
  "from": "from",
  "remove": "Remove",
  "addWindow": "+ Add time window",
  "scheduleHint": "No days = every day. No windows = all day. A window ending before it starts runs past midnight (22:00–06:00).",
  "blackOption": "Black screen, sound off",
  "standbyOption": "Standby screen, sound off",
  "leaveDevice": "Leave as set on the device",
  "default": "Default",
  "custom": "Custom",
  "mute": "Mute",
  "volumeLevel": "Volume level",
  "volumeHint": "Applies to the main zone's video sound. Outside working hours the player is silent.",
  "muteSwitch": "Mute",
  "muteOn": "Sound off",
  "muteOff": "Sound on",
  "muteHint": "Silences every video and app on these players, whatever the volume below. The volume is kept for when you switch it back on.",
  "interval": "Screenshot interval",
  "off": "Off",
  "uploadWifi": "Only upload on Wi-Fi or Ethernet (they wait on the player otherwise)",
  "shotsHint": "Shows what's on screen in Monitoring. Each screenshot is about 80 KB; every 15 minutes is about 8 MB a day. Kept 7 days.",
  "unsaved": "Unsaved changes"
};
const ar: typeof en = {
  "secDevice": "الجهاز",
  "idleScreen": "شاشة الخمول",
  "restart": "جدول إعادة التشغيل",
  "dataSaving": "توفير البيانات",
  "location": "التحقق من موقعه",
  "locationShort": "الموقع",
  "locationHint": "كم مرة يبحث مشغل Android عن موقعه (Wi-Fi/GPS). تتبعه المناطق وتطبيقات الطقس والصلاة. كل 30 دقيقة يناسب الشاشات الثابتة؛ وبضع دقائق تناسب الشاشات في المركبات.",
  "locEveryMin": "كل دقيقة | كل {n} دقائق",
  "locEveryHour": "كل ساعة | كل {n} ساعات",
  "onceADay": "مرة في اليوم",
  "idleStandby": "علامة الانتظار (افتراضي)",
  "idleBlack": "شاشة سوداء",
  "idleLogo": "شعارك",
  "idleMessage": "رسالة",
  "idleImage": "صورة الشعار",
  "chooseImage": "اختر صورة…",
  "noImages": "ارفع صورة إلى المحتوى أولًا.",
  "idleText": "الرسالة",
  "idleTextPh": "مثال: أهلًا بكم! المحتوى قادم قريبًا.",
  "background": "الخلفية",
  "textColor": "النص",
  "idleHint": "تظهر عندما لا يكون هناك محتوى مجدول، وخارج ساعات العمل إذا ضُبطت على الانتظار. يُنزَّل الشعار مع المحتوى فيظهر دون اتصال.",
  "restartDaily": "إعادة تشغيل المشغّل كل يوم",
  "restartTime": "وقت إعادة التشغيل",
  "restartHint": "حسب ساعة الشاشة. دون اختيار أيام = كل يوم. يعود المشغّل إلى الشاشة خلال دقيقة.",
  "restartAt": "{time}، {days}",
  "savingOn": "تنزيل المحتوى الجديد في أوقات محددة فقط",
  "savingWifi": "على أندرويد، عبر Wi-Fi فقط (دون بيانات الجوال)",
  "savingHint": "يوفّر البيانات على الاتصالات المحدودة أو المزدحمة. يستمر عرض ما على المشغّل؛ ويصل المحتوى الجديد خلال الفترة. المشغّل الجديد الذي لا يعرض شيئًا ينزّل فورًا.",
  "savingAt": "التنزيل {from}–{to}",
  "idleShort": "الخمول",
  "restartShort": "إعادة التشغيل",
  "savingShort": "توفير البيانات",
  "deviceLogs": "سجلات الجهاز",
  "logsShort": "السجلات",
  "logWarn": "التحذيرات والأخطاء",
  "logError": "الأخطاء فقط",
  "logOff": "عدم جمع السجلات",
  "logCollect": "ما يُجمع",
  "logSend": "عدد مرات الإرسال",
  "sendX": "إرسال {when}",
  "everyMinute": "كل دقيقة",
  "logsHint": "ما يسجّله المشغّل وكم مرة يرسله (يظهر في الأخطاء والتحذيرات للمشغّل ويستخدمه فحص السلامة). الإرسال الأقل يوفّر البيانات على الاتصالات المحدودة؛ تبقى الأخطاء محفوظة على المشغّل حتى إرسالها.",
  "useGroupOrOrg": "استخدام إعداد المجموعة / المؤسسة",
  "orientQ": "تغيير الاتجاه إلى {label}؟ تدور الشاشة ويُعاد ترتيبها فور وصول التغيير إلى المشغل.",
  "scheduleLine": "{days} · {times} · خارج الساعات: {outside}",
  "pct": "{n}٪",
  "displayLine": "السطوع {b} · {o}",
  "everyNMin": "كل {n} دقيقة",
  "everyNHours": "كل {n} ساعات",
  "windowFrom": "الفترة {n} من",
  "windowTo": "الفترة {n} إلى",
  "secSchedule": "جدول العمل",
  "secDisplay": "العرض",
  "secSound": "الصوت",
  "secMonitoring": "المراقبة",
  "invalid": "إعدادات غير صالحة",
  "landscape": "أفقي",
  "portrait": "عمودي",
  "landscapeFlipped": "أفقي (مقلوب ١٨٠°)",
  "portraitFlipped": "عمودي (مقلوب ١٨٠°)",
  "outBlack": "شاشة سوداء، دون صوت",
  "outStandby": "شاشة الانتظار، دون صوت",
  "alwaysOn": "يعمل دائمًا",
  "everyDay": "كل يوم",
  "allDay": "طوال اليوم",
  "defaultVol": "افتراضي (١٠٠٪)",
  "muted": "مكتوم",
  "asDevice": "كما هو مضبوط على الجهاز",
  "everyHour": "كل ساعة",
  "shotsOff": "لقطات الشاشة متوقفة",
  "wifiOnly": "فقط عبر Wi-Fi أو Ethernet",
  "anyNetwork": "عبر أي شبكة",
  "saving": "جارٍ الحفظ…",
  "save": "حفظ",
  "openOn": "يعمل في",
  "outsideHours": "خارج ساعات العمل",
  "brightness": "السطوع",
  "orientation": "الاتجاه",
  "volume": "مستوى الصوت",
  "screenshots": "لقطات الشاشة",
  "useDefault": "استخدام الإعداد الافتراضي للمؤسسة",
  "days": "الأيام",
  "to": "إلى",
  "from": "من",
  "remove": "إزالة",
  "addWindow": "+ إضافة فترة زمنية",
  "scheduleHint": "بلا أيام = كل يوم. بلا فترات = طوال اليوم. الفترة التي تنتهي قبل بدايتها تمتد بعد منتصف الليل (٢٢:٠٠–٠٦:٠٠).",
  "blackOption": "شاشة سوداء، دون صوت",
  "standbyOption": "شاشة الانتظار، دون صوت",
  "leaveDevice": "الإبقاء كما هو مضبوط على الجهاز",
  "default": "افتراضي",
  "custom": "مخصص",
  "mute": "كتم",
  "volumeLevel": "مستوى الصوت",
  "volumeHint": "ينطبق على صوت الفيديو في القسم الرئيسي. خارج ساعات العمل يكون المشغل صامتًا.",
  "muteSwitch": "كتم الصوت",
  "muteOn": "الصوت مغلق",
  "muteOff": "الصوت يعمل",
  "muteHint": "يكتم كل الفيديوهات والتطبيقات على هذه المشغلات مهما كان مستوى الصوت أدناه، ويُحفظ المستوى لحين إعادة التشغيل.",
  "interval": "فاصل لقطات الشاشة",
  "off": "متوقف",
  "uploadWifi": "الرفع عبر Wi-Fi أو Ethernet فقط (تنتظر على المشغل خلاف ذلك)",
  "shotsHint": "يعرض ما على الشاشة في المراقبة. كل لقطة نحو ٨٠ كيلوبايت؛ كل ١٥ دقيقة تعني نحو ٨ ميغابايت يوميًا. تُحفظ ٧ أيام.",
  "unsaved": "تغييرات غير محفوظة"
};
export default { en, ar };
